import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
const AdminRoute = ({children, setAlert}) => {
    const navigate = useNavigate();
    const { isLogged,isAdmin, logout, user } = useContext(AuthContext);    
    if (!isLogged || !user || (user.role != 1 && user.role != 3)) {
      setAlert({ type: "danger", message: "Vous devez être connecté en tant qu'administrateur pour accéder à cette page." });
      navigate("/connexion");
      logout();
      return null;
    }
    return children;
}

export default AdminRoute